import React, { useState } from 'react';
import './CircularCarousel.css';
import { Link } from 'react-router-dom';


const CircularCarousel = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const angleStep = 30;
  const radiusX = 500;
  const radiusY = 180;
  const visibleRange = 2;

  const moveTo = (targetIndex) => {
    const total = data.length;
    let current = activeIndex;
    const next = (targetIndex + total) % total;

    const forwardSteps = (next - current + total) % total;
    const backwardSteps = (current - next + total) % total;

    const step = forwardSteps <= backwardSteps ? 1 : -1;
    const steps = Math.min(forwardSteps, backwardSteps);

    let i = 0;
    const animate = () => {
      current = (current + step + total) % total;
      setActiveIndex(current);
      i++;
      if (i < steps) {
        setTimeout(animate, 150); // smooth transition
      }
    };
    animate();
  };

  const moveNext = () => moveTo(activeIndex + 1);
  const movePrev = () => moveTo(activeIndex - 1);

  const getOffset = (i) => {
    const total = data.length;
    let offset = i - activeIndex;
    if (offset > total / 2) offset -= total;
    if (offset < -total / 2) offset += total;
    return offset;
  };

  const getPositionStyle = (offset) => {
    const angle = offset * angleStep * (Math.PI / 180);
    const x = radiusX * Math.sin(angle);
    const y = -radiusY * Math.cos(angle);

    return {
      transform: `translate(-50%, -50%) translate(${x}px, ${y + 100}px)`,
      zIndex: 100 - Math.abs(offset),
      opacity: Math.abs(offset) > visibleRange ? 0 : 1,
      pointerEvents: Math.abs(offset) > visibleRange ? 'none' : 'auto',
    };
  };

  return (
    <div className="arc-carousel-wrapper">
      <button className="arc-arrow left" onClick={movePrev}>‹</button>

      <div className="arc-carousel-container">
        <div className="arc-carousel-circle">
          {data.map((item, i) => {
            const offset = getOffset(i);
            const styles = getPositionStyle(offset);
            return (
              <Link
                key={i}
                to={`/PopularDestinations?category=${encodeURIComponent(item.name)}`}
                className={`arc-carousel-item ${i === activeIndex ? 'active' : ''}`}
                style={styles}
                onClick={() => moveTo(i)}
              >
                <div
                  className="carousel-image"
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <div className="carousel-content">
                  <h3>{item.name}</h3>
                  <p>Read More</p>
                </div>
              </Link>
            );
        })}
        </div>

        <div className="arc-carousel-dots">
          {data.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === activeIndex ? 'active' : ''}`}
              onClick={() => moveTo(i)}
            />
          ))}
        </div>
      </div>

      <button className="arc-arrow right" onClick={moveNext}>›</button>
    </div>
  );
};

export default CircularCarousel;
